<template>
  <div class="dialog-wrapper">
    <el-dialog
      :title="`查看${planLevel}级开班计划`"
      :custom-class="'plan-class'"
      :visible.sync="isShowDialog"
      :before-close="handleBeforeClose"
      width="780px"
    >
      <div>
        <div class="content-box">
          <div class="loading-wrapper" v-if="isLoading" style="height: 400px">
            <yioks-loading v-show="isLoading"></yioks-loading>
          </div>
          <template v-if="!isLoading">
            <div class="content-wrap-view">
              <vue-scroll :ops="vuescrollOpt">
                <div class="scroll-content-view">
                  <template v-for="(item, index) in classPlanDate">
                    <fieldset class="border-set">
                      <legend class="legend-title">开班计划{{index+1}}</legend>

                      <div class="yioks-flex-box">
                        <div class="yioks-flex-item">
                          <p class="info">
                            <span class="info-label">开班时间:</span>
                            <span class="width">{{item.start_date | time(false)}}--{{item.end_date | time(false)}}</span>
                          </p>
                        </div>
                      </div>
                      <div class="yioks-flex-box">
                        <div class="yioks-flex-item">
                          <p class="info">
                            <span class="info-label">主讲师:</span>
                            <span class="width">{{item.teacher_off_name || "足协指派"}}</span>
                          </p>
                        </div>
                      </div>
                      <div class="yioks-flex-box">
                        <div class="yioks-flex-item">
                          <p class="info">
                            <span class="info-label">助理讲师:</span>
                            <span class="width">{{item.teacher_name || "--" }}</span>
                          </p>
                        </div>
                      </div>
                      <div class="yioks-flex-box" v-if="item.lecturer_assistant_id_number">
                        <div class="yioks-flex-item">
                          <p class="info">
                            <span class="info-label">讲师助理:</span>
                            <span class="width1">{{item.lecturer_assistant_name}}</span>
                            <span class="info-label">身份证:</span>
                            <span class="width1">{{item.lecturer_assistant_id_number}}</span>
                          </p>
                        </div>
                      </div>
                      <div class="yioks-flex-box" v-if="item.lecturer_assistant_two_id_number">
                        <div class="yioks-flex-item">
                          <p class="info">
                            <span class="info-label">讲师助理:</span>
                            <span class="width1">{{item.lecturer_assistant_two_name}}</span>
                            <span class="info-label">身份证:</span>
                            <span class="width1">{{item.lecturer_assistant_two_id_number}}</span>
                          </p>
                        </div>
                      </div>
                      <div class="yioks-flex-box">
                        <div class="yioks-flex-item">
                          <p class="info">
                            <span class="info-label">开班地区:</span>
                            <span class="width"> {{ item.province_name }}
                              {{ item.city_name }}
                              {{ item.county_name || "--" }}</span>
                          </p>
                        </div>
                      </div>
                      <div class="yioks-flex-box">
                        <div class="yioks-flex-item">
                          <p class="info">
                            <span class="info-label">备注:</span>
                            <span class="width">{{ item.info || "--" }}</span>
                          </p>
                        </div>
                      </div>
                    </fieldset>
                  </template>
                </div>
              </vue-scroll>
            </div>
          </template>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import createScrollOpt from "@/assets/js/vuescrollOption";
import {claassPlanOrganInfo} from "@/api/class_plan/api";
import { defaultFormat } from 'moment';

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
    planId: {
      type: Number,
      default: null,
    },
    orgId: {
      type: Number,
      default: null,
    },
    planLevel: {
      type: String,
      default: null,
    },
  },
  components: {
    "yioks-empty": () => import("@/components/Tips/Empty-grey"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
  },

  data() {
    return {
      isLoading: false,
      classPlanDate: [],
      vuescrollOpt: createScrollOpt(true),
    };
  },

  created() {
    this.getClaassPlanOrganInfo();
  },

  methods: {
    getClaassPlanOrganInfo(){
      if(!this.planId) return;
      this.isLoading = true;
      claassPlanOrganInfo({
        plan_id:this.planId,
        org_id:this.orgId,
      }).then(({data}) => {
        this.isLoading = false;
        this.classPlanDate = data.result;
        if(data.status !== 0){
          this.$message.error(data.msg);
          return;
        }
      })
      .catch((err) => {
        this.isLoading = false;
        console.error("err", err);
      });
    },

    handleBeforeClose() {
      this.$emit("update:isShowDialog", false);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/mixin'
@import '~@/assets/css/defaultPage'
@import '~@/assets/css/yioksCommon'
$border_color = #666
.content-wrap-view
  font-size $font_size_medium
  height 510px
.scroll-content-view
  width 730px
  color $border_color
  margin 0 25px
  padding-bottom 10px
.border-set
  border 1px solid $border_color
  margin 10px 10px 30px
  padding 10px 15px
  &:last-child
    margin-bottom 0px
  .legend-title
    margin-left 20px
    padding 0 5px
    font-size $font_size_medium
.width
  width 100%
.width1
  width 50%
.info
  display flex
  min-height 40px
  justify-content flex-start
.info-label
  margin-right 10px
  display block
  width 100px
  text-align right
</style>

<style lang="stylus">
.plan-class
  .el-dialog__body
    padding 0 0 20px 0 !important
</style>
<style lang="stylus">
@import '~@/assets/css/yioks-element-mixins'
</style>
